import { ImageInfo } from './common';

export class PaymentRequest {
    constructor() {
        this.amount = '';
        this.requestedBy = null;
        this.requestedReason = null;
        this.subdomain = null;
        this.bankId = null;
        this.bankReceipt = new ImageInfo()
    }
    public subdomain:string;
    public amount: string;
    public requestedBy: string;
    public requestedTo: string;
    public requestedReason: string;
    public transferType: string;
    public depositedDate: Date;
    public bankReferenceId: string;
    public requestedOn: Date;
    public status: string;
    public updatedOn: Date;
    public declinedReason: string;
    public bankId: string;
    public bankReceipt: ImageInfo
}